import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import TextInput from '../form-fields/text-input';
import GenericForm from '../form-fields/generic-form';
import { forgotPassword, RESET_PASSWORD } from '../../redux/modules/authentication';
import { errorPropTypes } from '../../util/proptype-utils';
import styles from './login.module.css';
import { getComponentTranslator } from '../../util/i18n';
import { Translate } from 'react-i18nify';

const translate = getComponentTranslator('forgotPassword');

const form = reduxForm({
  form: 'forgotPassword',
});

class ForgotPassword extends Component {
  state = {
    role: 'participant',
    teacherCode: ''
  };

  static propTypes = {
    forgotPassword: PropTypes.func,
    handleSubmit: PropTypes.func,
    errors: errorPropTypes,
    message: PropTypes.string,
    loading: PropTypes.bool,
  };

  static formSpec = [
    { id: 'email', name: 'email', label: 'Email Address', type: 'email', placeholder: 'you@yourdomain.com', component: TextInput },
    { id: 'password', name: 'password', label: 'New Password', type: 'password', placeholder: 'Enter new password', component: TextInput },
  ];

  handleFormSubmit = formProps => {
    const { role, teacherCode } = this.state;
    // Merge role and code into the submission data
    const submissionData = { ...formProps, role, teacherCode };

    return this.props.forgotPassword(submissionData).then(() => {
      // Success handled by Redux message
    });
  };

  render() {
    const { handleSubmit, errors, message, loading } = this.props;
    const { role, teacherCode } = this.state;

    return (
      <div className={styles.loginContainer}>
        <div className={styles.leftSection}>
          <video
            autoPlay
            muted
            loop
            className={styles.backgroundVideo}
            playsInline
          >
            <source src="https://videos.pexels.com/video-files/3125907/3125907-sd_640_360_25fps.mp4" type="video/mp4" />
          </video>
          <h2>Everything you need,<br />to make anything you want.</h2>
          <p>Dozens of creative tools to ideate, generate<br />and edit content like never before.</p>
        </div>

        <div className={styles.authBox}>
          <h1 className={styles.h1}>Reset Password</h1>
          <p className={styles.signUpText}>
            Remember your password? <Link to="/login">Log in</Link>
          </p>

          {/* Role Selection UI */}
          <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
            <button
              type="button"
              onClick={() => this.setState({ role: 'participant' })}
              style={{
                flex: 1,
                padding: '10px',
                background: role === 'participant' ? '#3b82f6' : '#1e293b',
                border: '1px solid #334155',
                color: 'white',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Elev / Deltagare
            </button>
            <button
              type="button"
              onClick={() => this.setState({ role: 'teacher' })}
              style={{
                flex: 1,
                padding: '10px',
                background: role === 'teacher' ? '#3b82f6' : '#1e293b',
                border: '1px solid #334155',
                color: 'white',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Lärare
            </button>
          </div>

          {role === 'teacher' && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', color: '#cbd5e1', marginBottom: '8px', fontSize: '0.9rem' }}>
                Lärarkod (Krävs)
              </label>
              <input
                type="password"
                value={teacherCode}
                onChange={(e) => this.setState({ teacherCode: e.target.value })}
                placeholder="Ange din lärarkod"
                style={{
                  width: '100%',
                  padding: '10px',
                  background: '#0f172a',
                  border: '1px solid #334155',
                  borderRadius: '8px',
                  color: 'white',
                  fontSize: '1rem'
                }}
              />
            </div>
          )}

          <GenericForm
            onSubmit={handleSubmit(this.handleFormSubmit)}
            errors={errors}
            message={message}
            formSpec={ForgotPassword.formSpec}
            submitText="Update Password"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  errors: authentication.errors[RESET_PASSWORD],
  message: authentication.messages[RESET_PASSWORD],
  loading: authentication.loading[RESET_PASSWORD],
});

export default connect(mapStateToProps, { forgotPassword })(form(ForgotPassword));